<template>
  <div class="">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <div class="">
      <Table :title="'电池告警信息'" :config="config1" :is600="true"></Table>
      <div class="flex">
        <BatteryRightLine class="flex1"/>
        <BatteryRightGauge class="flex1"/>
      </div>
      <div class="margin-right-xs flex1">
        <div class="margin-top-sm">
        </div>
        <!-- <Table :title="'维修记录'" :config="config2" :is400="true"></Table> -->
        <Table :title="'电池单体明细'" :config="config3" :is155="true"></Table>
      </div>
      <div class="margin-right-xs flex1">
        <Table :title="'电池服务车辆'" :config="config4" :is400="true"></Table>
        <Table :title="'电池充电记录'" :config="config5" :is400="true"></Table>
      </div>
    </div>
    
  </div>
</template>

<script>
import Table from "@/components/common/table";
// 头部
import BigTitle from '../bigTitle';
import { batteryHolderRight } from '@/api/batteryHolder/right';
import { dataInterface } from '@/api/dataInterfaceApi';
import { formatTime } from '@/utils/index';
import BatteryRightLine from "@/components/echart/batteryHolderCharts/batteryRightLine";
import BatteryRightGauge from "@/components/echart/batteryHolderCharts/batteryRightGauge";

export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'电池告警',
        ENG:'Battery compartment'
      },
      // 电池告警信息
      config1: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 12, //表格行数
        header: ["告警时间", "电池包编码", "故障原因"],
        data: [],
      },
      // 维修记录
      config2: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 8, //表格行数
        header: ["维修时间", "处理内容", "故障原因", "更换设备", "返回时间"],
        data: [],
      },
      // 电池单体明细
      config3: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 3, //表格行数
        header: ["电池单体编号", "记录时间", "单体电压", "单体温度"],
        data: [],
      },
      // 电池服务车辆
      config4: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 8, //表格行数
        header: ["车牌号", "换上时间", "换电站", "换下时间","换电站"],
        data: [],
      },
      // 电池充电记录
      config5: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 8, //表格行数
        header: ["充电时间", "充入电量", "站点"],
        data: [],
      },
    };
  },
  components: {
	BigTitle,
	Table,
  BatteryRightLine,
  BatteryRightGauge
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryAlarmDetail(data);
      this.selectBatteryMonomerInfo(data);
      this.selectBatteryServiceVehicle(data);
      this.selectBatteryChargingRecord(data);
      //维修记录
      this.selectMaintainRecord(data)
    },
    //维修记录
    selectMaintainRecord(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-weixiujilu',
          '@station_id':data.stationId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              item.guzhangsj,
              item.chulinr,
              item.guzhangyypg,
              item.peijianh,
              item.xiufusj
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config2 = {
              headerBGC: "rgba(53, 149, 147, 0.2)",
              headerHeight: 42,
              carousel: "single",
              hoverPause: true,
              oddRowBGC: "rgba(53, 149, 147, 0)",
              evenRowBGC: "rgba(53, 149, 147, 0)",
              rowNum: 8, //表格行数
              header:["维修时间", "处理内容", "故障原因", "更换设备", "返回时间"],
              data:newList
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //电池告警信息
    selectBatteryAlarmDetail(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-dianchigaojing',
          '@station_id':data.stationId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              formatTime(item.createTime,'yyyy-MM-dd HH:mm:ss'),
              item.batteryId,
              item.remarks
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config1 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 12, //表格行数
              header: ["告警时间", "电池包编码", "故障原因"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //TiDB-充电仓-电池单体明细
    selectBatteryMonomerInfo(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TD-congdiancang-dianchidantimingxi',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          console.log("电池单体明细",res)
          let newList = [];
          res = res[0];
          let batteryInfoSt = res.st.split('|');//单体温度
          let batteryInfoSv = res.sv.split('|');//单体温度
          let batterySt = batteryInfoSt.slice(2,batteryInfoSt.length);
          let batterySv = batteryInfoSv.slice(2,batteryInfoSt.length);
          console.log("电池单体明细",batterySt);
          [...batterySt].map((item,index) => {
						let arrlist = [
              index+1,
              formatTime(res.ts,'yyyy-MM-dd HH:mm:ss'),
              batterySv[index],
              item
            ];
						newList.push(arrlist)
          });
					_this.config3 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 3, //表格行数
              columnWidth:[150,150],
              align:['center','center','center','center'],
              header:["电池单体编号", "记录时间", "单体电压", "单体温度"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //电池服务车辆
    selectBatteryServiceVehicle(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-dianchifuwucheliang',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          console.log("服务车辆",res)
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              item.licensePlate,
              formatTime(item.upTime,'yyyy-MM-dd HH:mm:ss'),
              item.upStationName,
              formatTime(item.downTime,'yyyy-MM-dd HH:mm:ss'),
              item.downStationName,
            ];
						newList.push(arrlist)
          });
					_this.config4 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 8, //表格行数
              header:["车牌号", "换上时间", "换电站", "换下时间","换电站"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //电池充电记录
    selectBatteryChargingRecord(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-dianchichongdianjilu',
          '@station_id':data.stationId,
          '@battery_id':data.batteryId,
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
            // startTime、stationName、province
						let arrlist = [
              formatTime(item.startTime,'yyyy-MM-dd HH:mm:ss'),
              item.rechargeNum,
              item.stationName,
            ];
						newList.push(arrlist)
          });
          // licensePlate车牌号、changeStationName换上站点、replacementStationName换下站点、changeTheTime换上时间、replacementTime换下时间
          console.log('newList',newList)
					_this.config5 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 8, //表格行数
              header:["充电时间", "充入电量", "站点"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
  }
}
</script>
<style lang="scss" scoped>
.header-item{
  color:#0CB3AE;
}
</style>
